

const ExternalLink: React.FunctionComponent<any> = ({link, children}) => {
    return (
        <a href={link} target="_blank" rel="noreferrer noopener">{children}</a>
    )
}

export default ExternalLink;